import React from 'react'
import classNames from 'classnames'
import { getKey } from '@helpers/env'
import { BREAKPOINT_SIZES } from '@consts/index'
import { useMediaQuery } from '@helpers/hooks'
import Title from '@components/ui/type/Title'
import styles from './styles.module.scss'
import title from './title.module.scss'

type FormHeaderProps = {
  content: {
    byline?: string[]
    title: string
    image: {
      desktop?: string
      mobile: string
    }
  }
  classes?: string
  children?: React.ReactNode
}

export function ReturnsHeaderImage({
  content,
  classes,
  children
}: FormHeaderProps) {
  const isTabletUp = useMediaQuery({ minWidth: BREAKPOINT_SIZES.TABLET })
  const bgImage =
    isTabletUp && content?.image?.desktop
      ? content?.image?.desktop
      : content?.image?.mobile || ''
  const formHeaderStyles = classNames(styles.ReturnsHeader, classes)

  return (
    <div
      className={formHeaderStyles}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <Title
        type="h1"
        text={content.title}
        classes={`h2 title title--center ${
          content.title.includes('Unsubscribe') ? 'title--left-mobile' : ''
        }`}
      />
      {(content.byline || []).map((copy, i) => (
        <p key={getKey(i)} className={title.title__byline}>
          {copy}
        </p>
      ))}
      {children}
    </div>
  )
}
